const crudActionTypes = function (name) {
    const FETCH_ALL_PENDING = `${name}_FETCH_ALL_PENDING`;
    const FETCH_ALL_SUCCESS = `${name}_FETCH_ALL_SUCCESS`;
    const FETCH_ALL_ERROR = `${name}_FETCH_ALL_ERROR`;
    const FETCH_PENDING = `${name}_FETCH_PENDING`;
    const FETCH_SUCCESS = `${name}_FETCH_SUCCESS`;
    const FETCH_ERROR = `${name}_FETCH_ERROR`;
    const FETCH_HISTORY_PENDING = `${name}_FETCH_HISTORY_PENDING`;
    const FETCH_HISTORY_SUCCESS = `${name}_FETCH_HISTORY_SUCCESS`;
    const FETCH_HISTORY_ERROR = `${name}_FETCH_HISTORY_ERROR`;
    const EDIT_PENDING = `${name}_EDIT_PENDING`;
    const EDIT_DONE = `${name}_EDIT_DONE`;
    const SET_FILTER = `${name}_SET_FILTER`;
    const CREATE_PENDING = `${name}_CREATE_PENDING`;
    const CREATE_DONE = `${name}_CREATE_DONE`;

    return {
        FETCH_ALL_PENDING,
        FETCH_ALL_SUCCESS,
        FETCH_ALL_ERROR,
        FETCH_PENDING,
        FETCH_SUCCESS,
        FETCH_ERROR,
        FETCH_HISTORY_PENDING,
        FETCH_HISTORY_SUCCESS,
        FETCH_HISTORY_ERROR,
        EDIT_PENDING,
        EDIT_DONE,
        SET_FILTER,
        CREATE_DONE,
        CREATE_PENDING
    };
};

const readActionTypes = function (name) {
    const FETCH_ALL_PENDING = `${name}_FETCH_ALL_PENDING`;
    const FETCH_ALL_SUCCESS = `${name}_FETCH_ALL_SUCCESS`;
    const FETCH_ALL_ERROR = `${name}_FETCH_ALL_ERROR`;
    const FETCH_PENDING = `${name}_FETCH_PENDING`;
    const FETCH_SUCCESS = `${name}_FETCH_SUCCESS`;
    const FETCH_ERROR = `${name}_FETCH_ERROR`;
    const FETCH_HISTORY_PENDING = `${name}_FETCH_HISTORY_PENDING`;
    const FETCH_HISTORY_SUCCESS = `${name}_FETCH_HISTORY_SUCCESS`;
    const FETCH_HISTORY_ERROR = `${name}_FETCH_HISTORY_ERROR`;
    const SET_FILTER = `${name}_SET_FILTER`;

    return {
        FETCH_ALL_PENDING,
        FETCH_ALL_SUCCESS,
        FETCH_ALL_ERROR,
        FETCH_PENDING,
        FETCH_SUCCESS,
        FETCH_ERROR,
        FETCH_HISTORY_PENDING,
        FETCH_HISTORY_SUCCESS,
        FETCH_HISTORY_ERROR,
        SET_FILTER,
    };
};

export const ActionTypesFactory = {
    crudActionTypes,
    readActionTypes,
};
